export const COLORS = {
  PRIMARY: '#7fba00',
  SUCCESS: '#4CAF50',
  ERROR: '#F44336',
  WARNING: '#FF9800',
  INFO: '#2196F3',
  GREY: '#a5adb7',
  BLACK: '#000',
  WHITE: '#fff',
};

export const GRID_LINE_COLOR = COLORS.BLACK;

export const BASE_UNIT = 4;
export const REM = BASE_UNIT * 4;
